<template>
  <zg-module v-bind="moduleProps">
    <zg-reviewed-by
      v-bind="$props"
      :background="(backgroundSettings && backgroundSettings.backgroundColor) || 'white'"
    >
      <template #default>
        <slot />
      </template>
    </zg-reviewed-by>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgModule from '../ZgModule/ZgModule.vue'
  import ZgReviewedBy from '../../ZgReviewedBy/ZgReviewedBy.vue'
  export default {
    components: {
      ZgModule,
      ZgReviewedBy
    },
    mixins: [module],
    props: {
      title: {
        type: String,
        required: false,
        default: ''
      },
      image: {
        type: Object,
        required: false,
        default: null
      },
      name: {
        type: String,
        required: true
      },
      bioLink: {
        type: String,
        required: false,
        default: null
      },
      jobTitle: {
        type: String,
        required: false,
        default: null
      },
      date: {
        type: String,
        required: false,
        default: null
      }
    }
  }

</script>
